"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));
var _excluded = ["className", "classes", "dataMetrics"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultProps = {
  absolute: false,
  component: 'hr',
  dataMetrics: {
    root: 'fuse_divider'
  },
  light: false,
  variant: 'fullWidth'
};
var Divider = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var className = _ref.className,
    classes = _ref.classes,
    dataMetrics = _ref.dataMetrics,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement(_Divider["default"], (0, _extends2["default"])({
    className: className,
    classes: classes,
    "data-metrics": mergedDataMetrics.root,
    ref: ref
  }, rest));
});
Divider.displayName = 'Divider';
Divider.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Absolutely position the element. The absolute CSS class that gets applied has `left: 0; bottom: 0;`
   */
  absolute: _propTypes["default"].bool,
  /**
   * Override or extend the styles applied to the component. See [CSS API](https://v4.mui.com/api/divider/#css) for more details.
   *
   * root - Styles applied to the root element.
   *
   * absolute - Styles applied to the root element if absolute={true}.
   *
   * light - Styles applied to the root element if light={true}.
   *
   * middle - Styles applied to the root element if variant="middle".
   *
   */
  classes: _propTypes["default"].objectOf(_propTypes["default"].shape({
    absolute: _propTypes["default"].object,
    light: _propTypes["default"].object,
    middle: _propTypes["default"].object,
    root: _propTypes["default"].object
  })),
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * The component used for the root node. Either a string to use a DOM element or a component.
   */
  component: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * If true, the divider will have a lighter color.
   */
  light: _propTypes["default"].bool,
  /**
   * The variant to use.
   */
  variant: _propTypes["default"].oneOf(['fullWidth', 'middle'])
} : {};
Divider.defaultProps = defaultProps;
var _default = Divider;
exports["default"] = _default;